import { downloadChannels } from '@/mocks/home';

export default function DownloadChannels() {
  return (
    <section id="download" className="w-full bg-background-50">
      <div className="mx-auto max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="font-label text-xs tracking-[0.2em] text-primary-600">DOWNLOAD / APP 下载</span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              小蓝视频 APP 下载与安装包获取
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-7 text-foreground-600">
              以下四条渠道均为官方提供，按设备与使用习惯自行选择。移动端推荐扫码，桌面端推荐直链，临时浏览可直接走网页在线看。
            </p>
          </div>
          <span className="inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-full border border-primary-200 bg-primary-100 px-3.5 py-2 text-xs font-medium text-primary-700">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-verified-badge-line text-sm" />
            </span>
            渠道已校验
          </span>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {downloadChannels.map((channel) => (
            <div
              key={channel.id}
              className={
                channel.highlight
                  ? 'flex flex-col rounded-lg border border-primary-300 bg-primary-100/60 p-5'
                  : 'flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-200'
              }
            >
              <div className="flex items-start justify-between">
                <span
                  className={
                    channel.highlight
                      ? 'flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500 text-background-50'
                      : 'flex h-11 w-11 items-center justify-center rounded-lg bg-secondary-100 text-secondary-900'
                  }
                >
                  <i className={`${channel.icon} text-xl`} />
                </span>
                <span className="rounded-full bg-accent-100 px-2.5 py-1 font-label text-[11px] text-accent-900">
                  {channel.tag}
                </span>
              </div>

              <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">{channel.name}</h3>
              <p className="mt-1.5 text-xs text-foreground-500">{channel.platform}</p>

              <dl className="mt-4 space-y-2 border-t border-background-200/80 pt-4 text-xs">
                <div className="flex items-center justify-between gap-3">
                  <dt className="text-foreground-500">安装包体积</dt>
                  <dd className="font-medium text-foreground-800">{channel.size}</dd>
                </div>
                <div className="flex items-center justify-between gap-3">
                  <dt className="text-foreground-500">获取方式</dt>
                  <dd className="font-medium text-foreground-800">{channel.method}</dd>
                </div>
              </dl>

              <p className="mt-4 flex-1 text-xs leading-6 text-foreground-600">{channel.note}</p>

              <a
                href="#download"
                className={
                  channel.highlight
                    ? 'mt-5 flex cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600'
                    : 'mt-5 flex cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700'
                }
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className={channel.highlight ? 'ri-download-2-line text-base' : 'ri-arrow-right-line text-base'} />
                </span>
                {channel.highlight ? '前往下载' : '查看方式'}
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}